import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import DeepServicePage from '../../components/templates/DeepServicePage';
import KitchenServicePage from '../../components/templates/KitchenServicePage';
import ServicePageTemplate from '../../components/templates/ServicePageTemplate';
import { getServiceGuide } from '../../data/serviceGuides';
import { getService } from '../../data/services';
import { ROUTES } from '../../enum/routes';

export default function ServicePage() {
  const { serviceSlug } = useParams<{ serviceSlug: string }>();
  const service = serviceSlug ? getService(serviceSlug) : undefined;
  if (!service) return <Navigate to={ROUTES.SERVICE_AREAS} replace />;
  if (service.slug === 'kitchen-remodeling') return <KitchenServicePage />;
  const guide = getServiceGuide(service.slug);
  if (guide) return <DeepServicePage guide={guide} />;
  return <ServicePageTemplate service={service} />;
}
